<template>
  <div>
    <div class="vx-row justify-center">
      <div class="vx-col  w-full mt-8 mb-5">
        <h4 class="text-center ">
          Informacje o wykrytych klauzulach wyślemy na e-mail:</h4>
      </div>
    </div>
    <div class="vx-row justify-center">
      <div class="vx-col md:w-1/2 w-full">

        <vs-input size="large" autocmplete="email" placeholder="Email" name="email"
                  ref="email"
                  v-model="tmp.email"
                  @input="save('email')"
                  class="mt-5 w-full"/>

      </div>
    </div>

    <div class="vx-row justify-center">

      <div class="vx-col md:mt-5">
        <div class="demo-alignment">
          <div class="flex">
            <vs-checkbox
              v-model="tmp.premiumSupport" @change="update">Chcę, żeby moją umowę bezpłatnie przejrzał specjalista.
            </vs-checkbox>
          </div>
        </div>
      </div>
    </div>

    <transition name="slide">
      <div class="vx-row justify-center" v-show="tmp.premiumSupport">

        <div class="vx-col md:w-1/2 w-full mt-5">

          <vs-input size="large" autocomplete="given-name" placeholder="Imię" name="name"
                    ref="name"
                    v-model="tmp.name"
                    @input="save('name')"
                    class="mt-5 w-full"/>
          <vs-input size="large" autocomplete="family-name" placeholder="Nazwisko" name="surname"
                    ref="surname"
                    v-model="tmp.surname"
                    @input="save('surname')"
                    class="mt-5 w-full"/>
          <vs-input size="large" autocomplete="tel" type="tel" placeholder="Telefon" name="phone"
                    ref="phone"
                    v-model="tmp.phone"
                    @input="save('phone')"
                    class="mt-5 w-full"/>

          <br>

          <div :key="q.id" v-for="q in questions">
            <div v-if="['QUESTION_FULL', 'QUESTION_RADIO'].includes(q.type)">
              <div class="d-flex justify-content-between mt-2 pt-2 mb-1 pb-1">
                <p>{{q.title}}</p>
                <div>
                  <label class="mr-3">TAK
                    <input v-model="tmp.info[q.id].checked" type="radio" :name="q.id" :value="true"
                           @change="update"></label>
                  <label>NIE
                    <input v-model="tmp.info[q.id].checked" type="radio" :name="q.id" :value="false"
                           @change="update"></label>
                </div>
              </div>
              <transition name="slide">
                <vs-textarea v-if="q.type === 'QUESTION_FULL'" v-show="tmp.info[q.id].checked"
                             rows="3" :label="q.text"
                             v-model="tmp.info[q.id].answer"
                             @change="update"
                />
              </transition>

            </div>
            <div v-if="q.type === 'QUESTION_TEXT'">
              <vs-textarea class="mt-5 pt-2 mb-1 pb-1"
                           rows="3" :label="q.text"
                           v-model="tmp.info[q.id].answer"
                           @change="update"/>
            </div>
          </div>

        </div>

      </div>
    </transition>
  </div>
</template>

<script>
  import { QUESTIONS } from '../../utils/questions';

  export default {
    name: "ClientInfo",
    props: {
      value: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        tmp: (() => ({
          ...this.value,
          info: QUESTIONS.reduce((p, n) => ({ ...p, [n.id]: {} }), {}),
          premiumSupport: false
        }))()
      }
    },
    computed: {
      questions() {
        return QUESTIONS;
      }
    },
    methods: {
      save(prop) {
        this.tmp[prop] = this.$refs[prop].$el.querySelector('input').value;
        this.update();
      },
      update() {
        this.$emit('input', this.tmp);
      }
    }
  }
</script>

<style scoped>

</style>
